export default function GroupFarmsPowerCurveComponents() {
    return (
        <div>
            <h1>Pagina en proceso :D Curva de Potencia</h1>
        </div>
    );
}
